import { Component, Input, OnInit }  from '@angular/core';
import { FormBuilder }               from '@angular/forms';
import { ActivatedRoute }            from '@angular/router';
import { UntilDestroy }              from '@ngneat/until-destroy';
import { EnumOuiNon }                from '@shared/enums/enumOuiNon';
import { PreconisationSelfcareComponent } from 'src/app/components/main/self-care/preconisation-selfcare/preconisation-selfcare.component';
import { HeaderStepComponent }       from '../../../shared/header-step/header-step.component';
import { PreconisationOavComponent } from '../../oav-phase-b/preconisation/preconisation-oav.component';
import { AbstractStep }              from '../abstract-step';

@UntilDestroy ()
@Component ({
              selector:    'app-step-four',
              templateUrl: './step-four.component.html',
              styleUrls:   ['./step-four.component.scss'],
              standalone:  true,
              imports: [
                HeaderStepComponent,
                PreconisationOavComponent,
                PreconisationSelfcareComponent,

              ],
              providers:   [],
            })
export class StepFourComponent extends AbstractStep implements OnInit {
  @Input ()
  state: EnumOuiNon;

  constructor (
    override _fb: FormBuilder, override route: ActivatedRoute,
  ) {
    super (_fb, route);
  }

  override ngOnInit (): void {
    super.ngOnInit();
  }

  nextStep (canNext: boolean) {
    this.next.emit (canNext);
  }
}
